<template lang="pug">
  .target.targets
    .toolbar
      .mobile-title
        span.mobile-title__number.semibold {{$route.meta ? $route.meta.number : '' }}
        span {{$route.meta ? $route.meta.title : '' }}
      .line.toolbar__line
        h1.title {{$route.meta ? $route.meta.title : '' }}
        e-button-add(
          v-if="hasDownloadFileButton && getFileNameDownload($route.name)"
          @click="handleDownload($route.name)"
          label="Скачать приложения к ТС"
          btnDefaultClass=" "
        ).actions-panel__button.btn-text.button.button_usual
      .line.toolbar__line
        .search-result(v-if="hasTargetTypeTable" )
          .body
            .table-choose-panel
              .toolbar-table.toolbar--no-padding
                .select.list.select--minsize(@click = "select1 = !select1") {{ select1_title }}
                  span.select-open
                  ul.select__list.reset-list(v-if="select1")
                    li.select__list-item(@click="switchTypeTable('TARGETS_TABLE', 'tab1', 'Целевые показатели')")
                      button.reset-btn.select__list-button Целевые показатели
                    li.select__list-item(@click="switchTypeTable('BALANCE_TABLE', 'tab2', 'Баланс количественных характеристик')")
                      button.reset-btn.select__list-button Баланс количественных характеристик

                    input(type="hidden" name="getTypeTable" v-model="typeTable")

        form(
          @submit.prevent="letSearch"
          title="Введите слово либо фразу и нажмите Enter чтобы начать поиск"
        ).search.toolbar__search
          input.search__input(type="search" placeholder="" v-model="searchModel")
        div.actions-panel.view-panel.view-panel_divide
          e-button-delete(
            v-show="checkedRows.length > 0"
            @click="onDeleteItem"
            title="Поставьте галочку напротив целевого показателя в таблице и нажмите сюда чтобы его удалить"
          ).actions-panel__button.btn-delete.reset-btn.button.button_delete.button_small.button_icon.e-button-delete
          e-button-add(
            @click="onCreateItem"
            title="Добавить целевой показатель"
            label="Добавить"
            btnDefaultClass="actions-panel__button btn-add green btn-add-target view-panel__button view-panel__button_add"
          ).btn-add-target
          e-button-add(
            v-if="hasItems"
            @click="showYearModal=true"
            label="Добавить столбец"
            btnDefaultClass=" "
          ).actions-panel__button.btn-text.button.button_usual
    e-modal(
      v-if="showYearModal"
      title="Выбор года"
      @close="showYearModal=false"
      @confirm="handleYear"
    )
      slot
        input.input(type="number" v-model="year")
    div(v-if="select1_tabs === 'tab1'")
      .content
        .table.overflow-hidden(v-if="hasItems")
          .theader-wrapper
            table(cellspacing="0" style="width: 100%" ref="tableHeader")
              colgroup
                template(v-for="(row, rowKey, index) in rows")
                  template(v-if="index === 0")
                    col(
                      v-for="col in row"
                      :width="col.width"
                    )
              thead
                tr(v-for="headerRow in tableHeaders")
                  th.table__th.semibold(
                    v-for="(headerCol, headerIndex) in headerRow"
                    :colspan="headerCol.colspan"
                    :rowspan="headerCol.rowspan"
                    :class="`field-${headerIndex} th-${headerCol.colspan || 0}-${headerCol.rowspan || 0}`"
                  )
                    span.display-flex.align-items-center.justify-center(style="gap:10px")
                      span {{headerCol.value}}
                      e-button-delete(
                        v-if="headerCol.columnEmpty === true"
                        @click="deleteEmptyColumn(headerCol.year)"
                      ).reset-btn.button.button_delete.button_small.button_icon

            e-perfect-scrollbar(
              ref="tablePS"
              :emitTypes="['vue']"
              @ps-scroll-x="scrollHandler($event.event)"
              :config="{suppressScrollY: false, suppressScrollX: false}"
            )
              .tbody-wrapper(:style="{'max-height':'calc(100vh - 375px)'}")
                table(cellspacing="0" style="width: 100%")
                  colgroup
                    template(v-for="(row, rowKey, index) in rows")
                      template(v-if="index === 0")
                        col(
                          v-for="col in row"
                          :width="col.width"
                        )
                  tbody(ref="tableBody")
                    tr(
                      v-for="row in rows"
                      :data-id="row[0].id"
                      :class="{'is-checked': (checkedRows.includes(row[0].id)) }"
                    )
                      td.table__td(
                        v-for="(col, colIndex) in row"
                        :title="colIndex > 0 ? 'Чтобы отредактировать значение используйте двойной клик' : ''"
                      )

                        div.flex-row(v-if="colIndex === 0")
                          div.sortable
                            div.arrows
                              span.up
                              span.down

                          label.custom-checkbox
                            input.visually-hidden.custom-checkbox__input(
                              type="checkbox"
                              :value="col.id"
                              @click="checkRow(col.id)"
                            )
                            span.custom-checkbox__block
                            span.custom-checkbox__text №&nbsp;{{col.value}}
                        span(
                          v-if="!col._isEdit"
                          @dblclick="setEdit(col, colIndex)"
                          @click="mobileSetEdit(col, colIndex)"
                          :title="colIndex > 0 ? 'Чтобы отредактировать значение используйте двойной клик' : ''"
                        )
                          template(v-if="colIndex > 0")
                            template(v-if="!col.value") -
                            template(v-else) {{col.value}}
                        div(
                          v-else
                          title="Нажмите Enter либо перестаньте редактировать значение чтобы его сохранить"
                        ).edit
                          select.select(v-if="col.type === 'select'" v-model="col.value"  @change="saveEdit(col)")
                            option(v-for="option in col.options" :value="option.name") {{option.name}}
                          input.input(
                            v-else
                            type="text"
                            @keyup.enter.prevent="saveEdit(col)"
                            v-model="col.value"
                          )
                          span.invalid.error.table-invalid {{col._error}}

        div(v-else).table.tscroll.table--forEdit.empty
          div.table__empty Ничего не найдено...



    div(v-if="select1_tabs === 'tab2'")
      div.content
        div(
          v-if="hasItems"
        ).table.tscroll.table--forEdit
          div.theader-wrapper
            table(cellspacing="0" style="width: 100%" ref="tableHeader")
              colgroup
                template(v-for="(row, rowKey, index) in rows")
                  template(v-if="index === 0")
                    col(
                      v-for="col in row"
                      :width="col.width"
                    )
              thead
                tr(v-for="headerRow in tableHeaders")
                  th.table__th.semibold(
                    v-for="(headerCol, headerIndex) in headerRow"
                    :colspan="headerCol.colspan"
                    :rowspan="headerCol.rowspan"
                    :class="`field-${headerIndex} th-${headerCol.colspan || 0}-${headerCol.rowspan || 0}`"
                  )
                    span.display-flex.align-items-center.justify-center(style="gap:10px")
                      span {{headerCol.value}}
                      e-button-delete(
                        v-if="headerCol.columnEmpty === true"
                        @click="deleteEmptyColumn(headerCol.year)"
                      ).reset-btn.button.button_delete.button_small.button_icon

            e-perfect-scrollbar(
              ref="tablePS"
              :emitTypes="['vue']"
              @ps-scroll-x="scrollHandler($event.event)"
              :config="{suppressScrollY: false, suppressScrollX: false}"
            )
              div.tbody-wrapper
                table(cellspacing="0" style="width: 100%" ref="tableHeader")
                  colgroup
                    template(v-for="(row, rowKey, index ) in rows")
                      template(v-if="index === 0")
                        col(
                          v-for="col in row"
                          :width="col.width"
                        )
                  tbody(ref="tableBody")
                    tr(
                      v-for="row in rows"
                      :data-id="row[0].id"
                      :class="{'is-checked': (checkedRows.includes(row[0].id))}"
                    )
                      td.table__td(
                        v-for="(col, colIndex) in row"
                        :title="colIndex > 0 ? 'Чтобы отредактировать значение используйте двойной клик' : 'Кликните по ряду и не отпуская кнопку мыши начните тянуть ряд вниз либо вверх чтобы сменить порядок'"
                      )

                        div.flex-row(v-if="colIndex===0")
                          div.sortable
                            div.arrows
                              span.up
                              span.down

                          label.radioButton.custom-checkbox
                            input.visually-hidden.custom-checkbox__input(
                              type="checkbox"
                              :value="col.id"
                              @click="checkRow(col.id)"
                            ).radio
                            span.custom-checkbox__block
                            span.custom-checkbox__text №&nbsp;{{col.value}}
                        div(
                          v-if="!col._isEdit"
                          @dblclick="setEdit(col, colIndex)"
                          :title="colIndex > 0 ? 'Чтобы отредактировать значение используйте двойной клик' : 'Кликните по ряду и не отпуская кнопку мыши начните тянуть ряд вниз либо вверх чтобы сменить порядок'"
                        )
                          template(v-if="colIndex > 0")
                            template(v-if="col.value === null") -
                            template(v-else) {{col.value}}
                        div(
                          v-else
                          title="Нажмите Enter либо перестаньте редактировать значение чтобы его сохранить"
                        ).edit
                          input(
                            type="text"
                            @keyup.enter.prevent="saveEdit(col)"
                            v-model="col.value"
                          ).input
                          span.invalid.error.table-invalid {{col._error}}

        div(v-else).table.tscroll.table--forEdit.empty
          table(cellspacing="0")
            tr
              td Ничего не найдено...


    router-view

</template>

<script>
import { indicator } from '@/api/api-endpoints'
import { typeTable } from '@/mixins/targetMixin'
import targetsTableMixin from './mixins/targets-table'
import year from '@/utils/year'
import downloadFileMixin from '@/mixins/download-file-mixin'
import hasMixin from '@/mixins/has-mixin'

export default {
  name: 'targets',
  mixins: [targetsTableMixin, downloadFileMixin, hasMixin],
  data() {
    return {
      tabView: 'tab1',
      select1: false,
      select1_tabs: 'tab1',
      year: year.getCurrentYear(),
      showYearModal: false,
      select1_title:
        localStorage.getItem('typeTable') == typeTable.BALANCE_TABLE
          ? 'Баланс количественных характеристик'
          : 'Целевые показатели',
    }
  },
  methods: {
    getObjectPlanFactUpdateUrl(id, year) {
      return indicator.objectPlanFactUpdate(id, year)
    },
    getEndpoint(route) {
      if (!this.hasTargetTypeTable) {
        route.query.type_table = typeTable.TARGETS_TABLE
      } else {
        route.query.type_table =
          localStorage.getItem('typeTable') || typeTable.TARGETS_TABLE
      }
      return indicator.objects(route)
    },
    getDeleteUrl(id) {
      return indicator.objectDelete(id)
    },
    getUpdateUrl(id) {
      return indicator.objectUpdateOrCreate(id)
    },
    objectEmptyTableTypeYear(year, typeTable) {
      return indicator.objectEmptyTableTypeYear(year, typeTable)
    },
    getDeleteEmptyColumnUrl(year) {
      const type = typeTable[this.typeTable]
      return indicator.objectDeleteEmptyYear(year, type)
    },
    handleYear() {
      this.addNewCol({})
      this.showYearModal = false
    },
  },
}
</script>
